<template>
  <common-addon>
    <template v-slot:upsell>
      <subtitle :sub-title="$t('billing.success.confirmation.workspace_assign_desc')" />
      <zm-button size="large" type="primary" round @click="navigateToWorkspaceManagement">
        {{ $t('billing.success.confirmation.workspace_cta') }}
      </zm-button>
    </template>

    <template v-slot:unassign>
      <subtitle :sub-title="assignText" />
      <div>
        <zm-button size="large" type="primary" round @click="navigateToWorkspaceManagement">
          {{ $t('billing.success.confirmation.workspace_cta') }}
        </zm-button>
        <view-account type="plain" />
      </div>
    </template>
  </common-addon>

</template>
<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import { navigateToTargetPage } from '@/utils/modal-utils';

export default {
  extends: CommonAddon,
  components: {
    CommonAddon,
    Subtitle,
  },
  computed: {
    assignText() {
      return this.$t('billing.success.downgrade_unassign_workspaces', [this.unassignLicenses, this.billingDate]);
    },
  },
  methods: {
    navigateToWorkspaceManagement() {
      const workspaceManagementLink = '/workspaces/management';
      navigateToTargetPage(workspaceManagementLink);
    },
  },
};
</script>
